"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { SupportTiers } from "./support-tiers";
import { DocumentationHub } from "./documentation-hub";
import { OnboardingSupport } from "./onboarding-support";
import { TechnicalSupport } from "./technical-support";
import { ApiSupport } from "./api-support";
import { TrainingEducation } from "./training-education";
import { DedicatedAccount } from "./dedicated-account";
import { KnowledgeBase } from "./knowledge-base";
import { SupportEscalation } from "./support-escalation";
import { PlatformStatusIncidents } from "./platform-status-incidents";
import { CommunityForums } from "./community-forums";
import { SecurityCompliance } from "./security-compliance";
import { FeedbackImprovement } from "./feedback-improvement";
import { BillingAccount } from "./billing-account";
import { ContactSupport } from "./contact-support";
import { SupportCta } from "./cta";

export function SupportPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-crimson">
        <ExecutiveSummary />
      </div>
      <SupportTiers />
      <div className="bg-aurora-cyan">
        <DocumentationHub />
      </div>
      <OnboardingSupport />
      <div className="bg-aurora-emerald">
        <TechnicalSupport />
      </div>
      <ApiSupport />
      <div className="bg-aurora-amber">
        <TrainingEducation />
      </div>
      <DedicatedAccount />
      <div className="bg-aurora-purple">
        <KnowledgeBase />
      </div>
      <SupportEscalation />
      <div className="bg-aurora-cyan">
        <PlatformStatusIncidents />
      </div>
      <CommunityForums />
      <div className="bg-aurora-emerald">
        <SecurityCompliance />
      </div>
      <FeedbackImprovement />
      <div className="bg-aurora-amber">
        <BillingAccount />
      </div>
      <ContactSupport />
      <SupportCta />
    </>
  );
}
